import React, { useMemo } from 'react';

import { useEditionAwareness } from '../../../services/edition-awareness-context';
import { getJiraApplicationKey } from '../../../services/get-jira-application-key';
import { getJiraProjectTypeKey } from '../../../services/get-jira-project-type-key';
import { ModalEntryPoint } from '../shared/modal-entry-point';

import { DIALOG_CONFIG } from './dialog-config';
import { entryPoint, type EntryPointParams } from './freeToStandardModal.entrypoint';

export function FreeToStandardModal(): React.JSX.Element {
	const { product, cloudId } = useEditionAwareness();

	const jiraApplicationKey = getJiraApplicationKey(product);
	const projectType = getJiraProjectTypeKey(product);

	const entryPointParams: EntryPointParams = useMemo(
		() => ({
			cloudId,
			// Fallback to any valid value since this means that we're not using jira
			jiraApplicationKey: jiraApplicationKey ?? 'JIRA_SOFTWARE',
			// Fallback to any valid value since this means that we're not using jira
			projectType: projectType ?? 'SOFTWARE',
			isJira:
				product === 'jira' ||
				product === 'jira-product-discovery' ||
				product === 'jira-service-management',
			isConfluence: product === 'confluence',
		}),
		[cloudId, product, projectType, jiraApplicationKey],
	);

	const modalProps = useMemo(() => ({ width: 'x-large' }), []);

	return (
		<ModalEntryPoint
			entryPoint={entryPoint}
			entryPointParams={entryPointParams}
			modalProps={modalProps}
			dialogConfig={DIALOG_CONFIG}
		/>
	);
}
